import { http, results } from './client';

const seg = (value) => encodeURIComponent(String(value));

/**
 * Hotels near a point for a date, across all providers (60 per page).
 * Returns { hotels, page }.
 */
export const searchHotels = ({ date, page = 1, lat, lng, cc }) =>
  http
    .get(`api/v1/hotels/all/${seg(date)}/${seg(page)}/${seg(lat)}/${seg(lng)}/${seg(cc || 'us')}`)
    .then((r) => results(r) || { hotels: [], page });

/** Normalized hotel, or null when the provider doesn't know it. */
export const getHotel = ({ id, provider = 0, date }) =>
  http
    .get(`api/v1/hotels/${seg(id)}/${seg(provider)}/${seg(date)}`)
    .then((r) => results(r) ?? null);

/** Bookable rates (one per room × rate type × time slot) for a date and party size. */
export const getRooms = ({ id, provider = 0, date, guests = 1 }) =>
  http
    .get(`api/v1/hotels/booking/rooms/${seg(date)}/${seg(guests)}/${seg(id)}/${seg(provider)}`)
    .then((r) => results(r) || []);
